'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _components = require('components');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _lodash = require('lodash');

var _support = require('helpers/support');

var _lib = require('helpers/lib');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AllReward = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    districtOptions: state.address.districtOptions,
    user: state.auth.user,
    SUBCAT_FILTER: state.voucher.SUBCAT_FILTER,
    ALL_REWARD_LIST: state.voucher.ALL_REWARD_LIST,
    MY_REWARD_LIST: state.voucher.MY_REWARD_LIST,
    EXCHANGE_REWARD: state.voucher.EXCHANGE_REWARD
  };
}, {
  beforeExchangeReward: voucherActions.beforeExchangeReward,
  exchangeReward: voucherActions.exchangeReward,
  getMyReward: voucherActions.getMyReward,
  resetBooking: bookingActions.resetBooking,
  setDefaultBooking: bookingActions.setDefaultBooking,
  changeShopBeforeBooking: bookingActions.changeShopBeforeBooking,
  showDownloadAppPopup: setupActions.showDownloadAppPopup,
  setPathName: _setup.setPathName
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AllReward, _Component);

  function AllReward(props) {
    (0, _classCallCheck3.default)(this, AllReward);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AllReward.__proto__ || (0, _getPrototypeOf2.default)(AllReward)).call(this, props));

    _this.onChangeFilter = function (subCode) {
      if (typeof subCode === 'string') {
        var SUBCAT_FILTER_ACTIVE = _this.state.SUBCAT_FILTER_ACTIVE;

        SUBCAT_FILTER_ACTIVE = (0, _lodash.xor)(SUBCAT_FILTER_ACTIVE, [subCode]);
        _this.setState({ SUBCAT_FILTER_ACTIVE: SUBCAT_FILTER_ACTIVE });
      }
    };

    _this.getData = function () {
      var data = _this.props.ALL_REWARD_LIST.data;
      var SUBCAT_FILTER_ACTIVE = _this.state.SUBCAT_FILTER_ACTIVE;

      if (!SUBCAT_FILTER_ACTIVE || !SUBCAT_FILTER_ACTIVE.length) return data;
      data = data.filter(function (item) {
        var service = item.service || item.serviceRewrite;
        if (service && service.subcatInfo) {
          // filter .length tương đương với ý nghĩa tồn tại. Chỉ cần tồn tại một subcat nằm trong dịch vụ đó thì sẽ được show ra.
          return SUBCAT_FILTER_ACTIVE.filter(function (value) {
            return service.subcatInfo.findIndex(function (sc) {
              return sc.code === value;
            }) >= 0;
          }).length >= 1;
        }
        return false;
      });
      return data;
    };

    _this.renderAllReward = _this.renderRewardItem.bind(_this);
    _this.getButtonByShop = _this.getButtonByShop.bind(_this);
    _this.state = {
      showErr: false,
      contentErr: {
        title: { text: 'Lỗi', type: 'error' },
        message: []
      },
      showFlow: false,
      contentFlow: {
        title: { text: 'Thông Báo', type: 'success' },
        message: []
      },
      SUBCAT_FILTER_ACTIVE: []
      // showFilter: false,
    };
    _this.hideFlow = _this.hideFlow.bind(_this);
    _this.hideError = _this.hideError.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AllReward, [{
    key: 'getButtonExchangeReward',
    value: function getButtonExchangeReward(_ref) {
      var _this2 = this;

      var type = _ref.type,
          reward = _ref.reward;

      switch (type) {
        case 'EXCHANGE_REWARD_SUCCESS':
          return [this.getButtonByShop(reward.couponCode), {
            text: 'Ưu Đãi Của Tôi',
            onClick: function onClick() {
              _this2.hideFlow();
              _this2.toMyReward();
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        case 'REWARD_EXISTED':
          return [this.getButtonByShop(reward.couponCode), {
            text: 'Chi Tiết Ưu Đãi',
            onClick: function onClick() {
              return _this2.toBookingReward(reward.couponCode.code);
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        case 'EXCHANGE_REWARD_FAIL':
          return [{
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideError();
            }
          }];
        case 'CONFIRM_EXCHANGE_REWARD':
          return [{
            text: 'Chắc chắn',
            onClick: function onClick() {
              _this2.hideFlow();
              _this2.exchange(reward);
              _reactGa2.default.event({
                category: 'Promotion',
                action: 'Clicked Exchange button',
                label: '' + reward.packId
              });
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        case 'REQUIRE_LOGIN':
          return [{
            text: 'Đăng nhập',
            onClick: function onClick() {
              _this2.hideFlow();
              _this2.toLogin();
            }
          }, {
            text: 'Thoát',
            type: 'default',
            onClick: function onClick() {
              return _this2.hideFlow();
            }
          }];
        default:
          break;
      }
      return [];
    }
  }, {
    key: 'getButtonByShop',
    value: function getButtonByShop(coupon) {
      var _this3 = this;

      if (coupon && coupon.packageService) {
        var shop = coupon.packageService.shop;

        var btn = {};
        if (shop && shop.isBooking) {
          btn = {
            text: 'Đặt Lịch',
            onClick: function onClick() {
              _this3.hideFlow();
              _this3.toBooking(coupon);
            }
          };
        } else if (shop && !shop.isBooking) {
          btn = {
            text: 'Gọi Đặt Lịch',
            onClick: function onClick() {
              _this3.hideFlow();
              _this3.toCallShop(shop);
            }
          };
        }
        return btn;
      }
      return {};
    }
  }, {
    key: 'exchange',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(item) {
        var exchangeReward, res, content, couponCode;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                exchangeReward = this.props.exchangeReward;
                _context.next = 3;
                return exchangeReward(item);

              case 3:
                res = _context.sent;
                content = {};

                if (res.success) {
                  couponCode = res.couponCode;

                  if (res.type === 'TO_BOOKING') {
                    this.toBooking(couponCode);
                  } else {
                    content = res.content;
                    content.button = this.getButtonExchangeReward({
                      type: res.type,
                      reward: res.data
                    });
                    this.setState({ contentFlow: content, showFlow: true });
                  }
                } else {
                  content = res.content;
                  content.button = this.getButtonExchangeReward({
                    type: res.type,
                    reward: res.data
                  });
                  this.setState({ contentErr: content, showErr: true });
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function exchange(_x) {
        return _ref2.apply(this, arguments);
      }

      return exchange;
    }()
  }, {
    key: 'onExchange',
    value: function onExchange(e, item) {
      e.stopPropagation();
      this.props.showDownloadAppPopup();
      // const res = this.props.beforeExchangeReward(item);
      // if (res.type === 'REQUIRE_EXCHANGE_SHOP') {
      //   this.props.history.push(`/uu-dai/${item.handle}?branch=true`);
      // } else {
      //   const contentFlow = { ...res.content };
      //   contentFlow.button = this.getButtonExchangeReward({
      //     type: res.type,
      //     reward: res.data,
      //   });
      //   this.setState({ contentFlow, showFlow: true });
      // }
    }
  }, {
    key: 'toLogin',
    value: function toLogin() {
      this.props.setPathName('/uu-dai');
      this.props.history.push('/dang-nhap');
    }
  }, {
    key: 'toBooking',
    value: function toBooking(coupon) {
      this.props.showDownloadAppPopup();
      // const {
      //   packageService: { shop, service },
      //   code,
      // } = coupon;
      // const {
      //   resetBooking,
      //   setDefaultBooking,
      //   history,
      //   changeShopBeforeBooking,
      //   user,
      // } = this.props;
      // resetBooking();
      // changeShopBeforeBooking(shop, user);
      // const bookingServices = [
      //   { service: service._id, number: 1, name: service.name },
      // ];
      // const submit = { bookingServices, code, shop, coupon };
      // setDefaultBooking(submit);
      // history.push(`/dat-lich`);
    }
  }, {
    key: 'toCallShop',
    value: function toCallShop(shop) {
      if (shop) {
        window.open('tel:' + (0, _lib.getPhone)(shop.phone));
      }
    }
  }, {
    key: 'toMyReward',
    value: function toMyReward() {
      this.props.changeTab('myReward');
    }
  }, {
    key: 'toRewardDetail',
    value: function toRewardDetail(item) {
      this.props.history.push('/uu-dai/' + item.handle);
      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Clicked Voucher Card from All Reward',
        label: '' + item.packId
      });
    }
  }, {
    key: 'toBookingReward',
    value: function toBookingReward(code) {
      this.props.history.push('/uu-dai-cua-toi/' + code);
    }
  }, {
    key: 'showError',
    value: function showError() {
      this.setState({ showErr: true });
    }
  }, {
    key: 'hideError',
    value: function hideError() {
      this.setState({ showErr: false });
    }
  }, {
    key: 'showFlow',
    value: function showFlow() {
      this.setState({ showFlow: true });
    }
  }, {
    key: 'hideFlow',
    value: function hideFlow() {
      this.setState({ showFlow: false });
    }
  }, {
    key: 'handleChangeDistrict',
    value: function handleChangeDistrict(item) {
      if (item) {
        if (this.props.onChangeDistrict) {
          this.props.onChangeDistrict(item);
        }
      } else {
        if (this.props.onChangeDistrict) {
          this.props.onChangeDistrict(null);
        }
      }
      this.setState({ SUBCAT_FILTER_ACTIVE: [] });
    }
  }, {
    key: 'renderRewardItem',
    value: function renderRewardItem(item, i) {
      var _this4 = this;

      var userNo = this.props.userNo;

      var _item = _support.Helper.parsePackageServiceToCard(item);
      if (_item.forRank && _item.forRank.type && userNo !== -1) {
        var campaignNo = _support.Helper.rankNo(_item.forRank.type);
        _item.allowExchange = userNo >= campaignNo;
      }
      return _react2.default.createElement(_components.RewardItemV2, {
        key: 'rewardItem_' + item._id,
        item: _item,
        onPress: function onPress() {
          return _this4.toRewardDetail(_item);
        },
        onExchange: function onExchange(e) {
          return _this4.onExchange(e, _item);
        }
      });
    }
  }, {
    key: 'renderCompactFilter',
    value: function renderCompactFilter() {
      var _this5 = this;

      var styles = require('./LookmeReward.scss');
      var data = this.props.SUBCAT_FILTER.data;
      var SUBCAT_FILTER_ACTIVE = this.state.SUBCAT_FILTER_ACTIVE;

      return _react2.default.createElement(
        'div',
        { className: styles.filterBox },
        !!data && data.map(function (sub) {
          var active = !!(SUBCAT_FILTER_ACTIVE.indexOf(sub.code) !== -1);
          return _react2.default.createElement(
            'div',
            {
              key: 'filter-' + sub.code,
              className: styles.subcat + ' ' + (active ? styles.active : ''),
              onClick: function onClick() {
                return _this5.onChangeFilter(sub.code);
              }
            },
            sub.label
          );
        })
      );
    }
  }, {
    key: 'renderBottomFilter',
    value: function renderBottomFilter() {
      var styles = require('./LookmeReward.scss');

      var _props = this.props,
          districtOptions = _props.districtOptions,
          district = _props.district;

      return _react2.default.createElement(
        'div',
        { className: styles.bottomFilter },
        _react2.default.createElement('div', { className: styles.bgBlur }),
        _react2.default.createElement(
          'div',
          { className: styles.selectBox },
          _react2.default.createElement(_reactSelect2.default
          // ref={e => {
          //   this.selectProvince = e;
          // }}
          , { name: 'district'
            // onFocus={::this.onFocus}
            , placeholder: 'Qu\u1EADn/Huy\u1EC7n',
            className: styles.searchProvince + ' drop-up',
            value: district,
            onChange: this.handleChangeDistrict.bind(this),
            options: districtOptions,
            multi: false,
            searchable: false
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props2 = this.props,
          dynamicData = _props2.dynamicData,
          homeOff = _props2.homeOff;

      var data = this.getData();
      var mainData = dynamicData && dynamicData.length > 0 ? dynamicData : data;
      var _state = this.state,
          showErr = _state.showErr,
          contentErr = _state.contentErr,
          showFlow = _state.showFlow,
          contentFlow = _state.contentFlow;

      var styles = require('./LookmeReward.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.allReward },
        _react2.default.createElement(
          'div',
          { className: styles.listVoucher },
          this.renderCompactFilter(),
          !!(mainData && mainData.length) ? mainData.map(function (item, i) {
            return _this6.renderRewardItem(item, i);
          }) : _react2.default.createElement(
            'div',
            { className: styles.nodata },
            'Hi\u1EC7n t\u1EA1i ch\u01B0a c\xF3 khuy\u1EBFn m\xE3i n\xE0o!'
          )
        ),
        this.renderBottomFilter(),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'modal_flow',
          show: showFlow,
          onHide: this.hideFlow,
          title: contentFlow.title,
          message: contentFlow.message,
          button: contentFlow.button,
          closeButton: true
        }),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'modal_error',
          show: showErr,
          onHide: this.hideError,
          title: contentErr.title,
          message: contentErr.message,
          button: contentErr.button,
          closeButton: true
        })
      );
    }
  }]);
  return AllReward;
}(_react.Component), _class2.propTypes = {
  // @data
  district: _react.PropTypes.string,
  userNo: _react.PropTypes.number,
  user: _react.PropTypes.object,
  history: _react.PropTypes.object,
  SUBCAT_FILTER: _react.PropTypes.object,
  ALL_REWARD_LIST: _react.PropTypes.object,
  configHeader: _react.PropTypes.object,
  MY_REWARD_LIST: _react.PropTypes.object,
  EXCHANGE_REWARD: _react.PropTypes.object,
  districtOptions: _react.PropTypes.array,
  dynamicData: _react.PropTypes.array,
  homeOff: _react.PropTypes.bool,
  // @action
  beforeExchangeReward: _react.PropTypes.func,
  exchangeReward: _react.PropTypes.func,
  changeTab: _react.PropTypes.func,
  setPathName: _react.PropTypes.func,
  setDefaultBooking: _react.PropTypes.func,
  resetBooking: _react.PropTypes.func,
  getMyReward: _react.PropTypes.func,
  changeShopBeforeBooking: _react.PropTypes.func,
  onChangeDistrict: _react.PropTypes.func,
  onChangeFilter: _react.PropTypes.func,
  showDownloadAppPopup: _react.PropTypes.func
}, _temp)) || _class);
exports.default = AllReward;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/AllReward.js
// module id = 719
// module chunks = 0